import { css } from "emotion";
import H4 from "../../../../components/global/H4";
import P from "../../../../components/global/P";
import Image from "../../../../components/Image";
import FlexRow from "./FlexRow";
import { max } from "../../../../utils/CssUtils";

const Quote = ({ image, imageAlt, quote, author }) => {
  const imageStyles = css({
    maxWidth: 180,
    maxHeight: 131,
    [max(600)]: {
      maxWidth: 130,
      maxHeight: 95
    }
  });

  const contentWrapper = css({
    textAlign: "left",
    margin: "auto 0 auto 32px",
    flexShrink: 2,
    maxWidth: 550,
    minHeight: 85,
    [max(600)]: {
      margin: "12px auto 0 auto",
      maxWidth: "100%",
      width: "100%",
      minHeight: 95
    }
  });

  return (
    <FlexRow style={{ justifyContent: "center" }}>
      <div style={{ textAlign: "center" }}>
        <Image styleSheet={imageStyles} imageURL={image} alt={imageAlt} />
      </div>
      <div className={contentWrapper}>
        <H4
          marginBottom={8}
          marginBottomMobile={4}
          style={{ fontWeight: "normal" }}
        >
          {quote}
        </H4>
        <P semiBold={true}>{author}</P>
      </div>
    </FlexRow>
  );
};

export default Quote;
